import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// 'root' div 요소를 찾아서 React 앱을 렌더링
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
